'use strict';

module.exports = ccount;

function ccount(value, character) {
  var count = 0;
  var index;

  value = String(value);

  if (typeof character !== 'string' || character.length !== 1) {
    throw new Error('Expected character');
  }

  index = value.indexOf(character);

  while (index !== -1) {
    count++;
    index = value.indexOf(character, index + 1);
  }

  return count;
}



//////////////////
// WEBPACK FOOTER
// ./~/ccount/index.js
// module id = 66
// module chunks = 96961042003272 139266963665775